import { compose, withStateHandlers, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import combineSelectors from 'utils/combineSelectors';
import {
  template,
  functionalGroupTemplates,
  designPackageForTemplate,
} from 'reducers/templates/selectors';

const mapStateToProps = combineSelectors({
  template,
  functionalGroupTemplates,
  designPackageForTemplate,
});

function componentDidMount() {
  const { selectedDesignOption, setExpandedOption } = this.props;
  setExpandedOption(selectedDesignOption);
}

const options = ({ primaryOptions, secondaryOptions }) =>
  primaryOptions.concat(secondaryOptions);

const setExpandedOption = () => option => ({ expandedOption: option });

const designPackage = ({ designPackageForTemplate, optionKey }) =>
  designPackageForTemplate[optionKey];

const selectExpandedOption = ({ setExpandedOption }) => option => {
  setExpandedOption(option);
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [],
  }),
  connect(
    mapStateToProps,
    {},
  ),
  // withStateHandlers({ selectedTemplateId: null }, { setSelectedTemplate }),
  withStateHandlers({ expandedOption: null }, { setExpandedOption }),
  lifecycle({ componentDidMount }),
  withHandlers({
    selectExpandedOption,
    // selectTemplateId,
  }),
  addProps({
    options,
    designPackage,
  }),
);
